import Head from 'next/head';
import type { GetStaticProps } from 'next';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useReactiveVar } from '@apollo/client';

import {
  ICountryList,
  TfrequenciesV2,
  allFiltersType,
  getCategorizedProductsType,
  plansType,
} from '@utils/types';
import OrderStepTwo from '@containers/OrderStepTwo';
import { redirectIndiaModalOnesOpenVar, utilsStateVar } from 'store/utils';
import { AppRoutes } from '@utils/appRoutes';
import PageLoader from '@components/PageLoader';
import { fetchServiceableCountries } from '@utils/fetchApi/fetchServiceableCountries';
import { fetchPlanAndFreq } from '@utils/fetchApi/fetchPlanAndFreq';
import { fetchCategorizedProduct } from '@utils/fetchApi/fetchCategorizedProduct';
import CombinedOrderStepOneAndTwo from '@containers/CombinedOrderStepOneAndTwo';

interface OrderFlowStepTwoProps {
  servicableCountriesResponse: {
    data: {
      getServiceableCountries: ICountryList[];
    };
  };
  plansAndFrequencies: {
    data: {
      getPlansAndFrequencies: {
        frequencies: string[];
        plans: plansType[];
        frequenciesV2: TfrequenciesV2[];
      };
    };
  };
  categorizedResponse: {
    data: {
      getCategorizedProducts: {
        categories: getCategorizedProductsType[];
        all_filters: allFiltersType[];
        allVariantMapping: any;
      };
    };
  };
  countryCode: string;
}

const OrderFlowStepTwo = ({
  servicableCountriesResponse,
  plansAndFrequencies,
  categorizedResponse,
  countryCode,
}: OrderFlowStepTwoProps) => {
  const { getServiceableCountries } = servicableCountriesResponse?.data || {};
  const { plans, frequencies, frequenciesV2 } =
    plansAndFrequencies?.data?.getPlansAndFrequencies || {};
  const { getCategorizedProducts } = categorizedResponse?.data || {};
  const { categories, all_filters, allVariantMapping } =
    getCategorizedProducts || {};

  const router = useRouter();

  const { isDirectRoutingValid } = useReactiveVar(utilsStateVar);
  const redirectIndiaModalOnesOpen = useReactiveVar(
    redirectIndiaModalOnesOpenVar
  );

  // useEffect(() => {
  //   if (!isDirectRoutingValid) {
  //     //router.push(`/${countryCode}${AppRoutes.ORDER_STEP_ONE}`);
  //     router.push(`${AppRoutes.HOME_ROUTE}`);
  //   }
  // }, [isDirectRoutingValid]);

  // if (!isDirectRoutingValid) {
  //   return <PageLoader />;
  // }

  const handleChange = () => {
    router.push(AppRoutes.HOME_ROUTE);
  };

  // for clear back stack
  useEffect(() => {
    if (redirectIndiaModalOnesOpen) {
      router.beforePopState(() => {
        return false;
      });
      window.addEventListener('popstate', handleChange);

      return () => {
        router.beforePopState(() => {
          return true;
        });
        window.removeEventListener('popstate', handleChange);
      };
    }
  }, [redirectIndiaModalOnesOpen]);

  return (
    <>
      <Head>
        <title>
          Menu | Taste of India - Delhi, Mumbai, Chennai | The Cumin Club
        </title>
      </Head>
      <CombinedOrderStepOneAndTwo
        getServiceableCountries={getServiceableCountries}
        plans={plans}
        frequencies={frequencies}
        frequenciesV2={frequenciesV2}
        categories={categories}
        getAllFilters={all_filters}
        allVariantMapping={allVariantMapping}
        countryCode={countryCode}
      />
    </>
  );
};

export default OrderFlowStepTwo;

export const getStaticProps: GetStaticProps = async () => {
  const countryCode = 'usa';

  const [
    servicableCountriesResponse,
    plansAndFrequencies,
    categorizedResponse,
  ]: any = await Promise.all([
    fetchServiceableCountries(),
    fetchPlanAndFreq({ countryCode }),
    fetchCategorizedProduct({ countryCode }),
  ]);

  // Pass data to the page via props
  return {
    props: {
      servicableCountriesResponse,
      plansAndFrequencies,
      categorizedResponse,
      countryCode,
    },
  };
};
